import React from 'react';
import { Provider } from 'models';
import { PrimaryButton, SecondaryButton } from 'library';
import useGoToProfile from './goToProfile';
import { useLocation } from 'react-router';
import { getObjectFromSearchString } from 'shared';

const GoToProfileAction = ({ provider, secondary = false }: { provider: Provider; secondary?: boolean }) => {
    const { goToProfile } = useGoToProfile();
    const searchQuery = useLocation().search;
    const searchObject = getObjectFromSearchString(searchQuery);

    const onClick = () => goToProfile(provider, 'View Profile Button Click', searchObject?.type);

    return secondary ? (
        <SecondaryButton onClick={onClick} textStyle={{ whiteSpace: 'nowrap', textOverflow: 'hidden' }}>
            View Profile
        </SecondaryButton>
    ) : (
        <PrimaryButton onClick={onClick} textStyle={{ whiteSpace: 'nowrap', textOverflow: 'hidden' }}>
            View Profile
        </PrimaryButton>
    );
};

export default GoToProfileAction;
